import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { toRaw, watchEffect } from 'vue';
import { useRoute } from 'vue-router';
import storage from './server/storage';
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {
    let route = toRaw(useRoute()).query;
    watchEffect(() => {
      if (route.value.token != undefined) {
        console.log(route.value.token);
        storage.setToken(route.value.token);
      }
      if (route.value.unitId != undefined) {
        storage.setUnitId(route.value.unitId);
      }
      if (route.value.userId != undefined) {
        storage.setUserId(route.value.userId);
      }
      if (route.value.appTag != undefined) {
        storage.setAppTag(route.value.appTag);
      }
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_component_router_view);
    };
  }
});